import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-user.png";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const ProfileDropdown = () => {
 const {t}=useTranslation();
    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" 
                            src={avatar1}
                            alt="HeaderSection Avatar" />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{currentUser?.fullName}</span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                <DropdownItem className='p-0'>
                        <Link to={`/profile/${currentUser?.userId}`} className="dropdown-item">
                        <i className="mdi mdi-email text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle email">{currentUser?.email}</span>
                        </Link>
                    </DropdownItem>
                    
                    <DropdownItem className='p-0'>
                        <Link to={`/profile/${currentUser?.userId}`} className="dropdown-item">
                        <i className="mdi mdi-cogs text-muted fs-16 align-middle me-1"></i>

                            <span className="align-middle parametre">{t("parametre.parametres")}</span>
                        </Link>
                    </DropdownItem>
                    
                    <DropdownItem className='p-0'>
                         <Link to="/aide" className="dropdown-item">
                            <i
                                className="bx bx-help-circle text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle">Besoin d'aide ?</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to={"/lock"} className="dropdown-item">
                            <i className="ri-lock-2-line text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle parametre">Verouiller</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to={process.env.PUBLIC_URL + "/logout"} className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle parametre" data-key="t-logout">Déconnexion</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;